import Vue from 'vue';
import { connect } from 'redux-vuex';
import store from './store';

connect({
  Vue,
  store,
});
